import React, { Component } from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import classes from './Menu.module.scss';
import globalJson from '../../../data/global.json';
import IsNotDomestic from 'helpers/IsNotDomestic';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

class Menu extends Component {

    constructor(props) {
        super(props);
        this.globalImages = this.props.globalImages;
        this.isHomepage = this.props.isHomepage;
        window.addEventListener('scroll', this.onScroll)
    }

    onClick(event){
		window.gtag('event', "client logo clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "client logo clicked "+ event.currentTarget.href,
			'value':10
          });
    }

    onClickBBCLogo(event){
		window.gtag('event', "BBC logo clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "BBC logo clicked "+ event.currentTarget.href,
			'value':10
          });

    }

    onScroll = () => {
        if (window.scrollY > 1) {
          document.getElementById("main_menu").classList.add("home_page__show");
        } else {
            document.getElementById("main_menu").classList.remove("home_page__show");
        }
      };

   
    render() {

        let menuContent =
        <div className={classes['main-menu__wrap']}>
            <div className={classes['main-menu-exposed']}>
                <div className={classes['main-menu-exposed__container']}>
                    <div className={classes['main-menu-exposed__left-container']}>
                        <div className={`${classes['main-menu-exposed__logo-container']} ${classes['main-menu__bbc-logo']}`}>
                            <a onClick={this.onClickBBCLogo} className={classes['main-menu-exposed__bbc-logo']} href={globalJson.menu.link} target="blank">
                                <img alt="{{@root.bbc.alt}}" src={getFileName(this.globalImages, 'bbc-logo.png')} />
                            </a>
                        </div>
                    </div>

                    <div className={classes['main-menu-exposed__right-container']}>
                        <IsNotDomestic>
                            <div className={`${classes['sponsor-link']} ${classes['style-light']}`}>
                                <p className={`${classes['sponsor-link__title']}
                                        ${classes['style-light']}`}
                                    dangerouslySetInnerHTML={{ __html: globalJson.menu.text }}>
                                </p>
                                <a onClick={this.onClick} className={`${classes['sponsor-link__logo-link']}`} href={globalJson.menu.client.link} target="_blank">
                                    <div  className={`${classes['main-menu-exposed__logo-container']}`}>
                                        <div
                                            className={`${classes['sponsor-link__logo']}`}
                                            style={{backgroundImage: `url(${getFileName(this.globalImages, 'client-logo.png')})`}}>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </IsNotDomestic>
                    </div>

                </div>
            </div>
        </div>
        
        return (
            <Switch>
				<Route exact path={`${process.env.PUBLIC_URL}(/index.html|/)`} render={(props) => 
					<div id={"main_menu"} className={`${classes['main-menu']} home_page`}>
                        {menuContent}
                    </div>				
				} />
						
				<Route path={`*/:articleTitle`} render={(props) => 			
                    <div id={"main_menu"} className={`${classes['main-menu']} articles_page`}>
                       {menuContent}
                    </div>				
				}/>
			</Switch>
            
        )
    }
}

export default Menu;